<template>
  <div
    class="edit-station edit-station-sprinklers"
  >
    <div class="edit-station-sprinklers__column">
      <select-element
        :title="'Sprinkler Type'"
        :value="computedSprinklerType"
        :list="computedSprinklerTypes"
        :emit-function-named="'setSprinklerType'"
        @setSprinklerType="setSprinklerType"
      />
      <precipitation-calculator
        v-if="station.sprinklType === '4'"
        :store="store"
        @transfer-precip="setPrecip"
      />
      <spray-precipitation-calculator
        v-if="station.sprinklType === '5'"
        :store="store"
        @transfer-precip="setPrecip"
      />
    </div>
    <div class="edit-station-parameters__column">
      <div 
        class="div_grouping"
        style="width: 80%"
      >
        <input-element
          class="edit-program__top-bar__name"
          :name="'Precipitation Rate'"
          :title="'Precipitation Rate'"
          :type="text"
          :disabled="!(station.sprinklType === '4' || station.sprinklType === '5')"
          :text="computedPrecipitationRate"
          :placeholder="'Precipitation Rate'"
          style="width: 75%; display: inline-block"
          @change="setPrecip"
        />
        <div 
          padding:0px
          margin:0px
          style="width: 20%; display: inline-block; text-align: right"
        >
          {{ getDenominator('centimetre', 'inch', 0) + '/' + $tc('messages.sharedTexts.time.h', 1) }}
        </div>
      </div>
      <select-element
        :title="'Efficiency'"
        :value="rating"
        :list="ratings"
        :emit-function-named="'setRating'"
        @setRating="setRating"
      />      
    </div>
    <!-- <div class="edit-station-sprinklers__column">
      <h4 class="g-title g-title--subtitle">
        Precipitation Rate
      </h4>
      <div>
        <input
          class="precipitationrate"
          type="text"
          :disabled="!(station.sprinklType === '4' || station.sprinklType === '5')"
          :value="computedPrecipitationRate"
          @change="setPrecip"
        >
        {{ getDenominator('centimetre', 'inch', 0) + '/' + $tc('messages.sharedTexts.time.h', 1) }}
      </div>
      <br>
      <hr>
      <select-element
        :title="'Efficiency'"
        :value="rating"
        :list="ratings"
        :emit-function-named="'setRating'"
        @setRating="setRating"
      />
    </div> -->
  </div>
</template>

<script>
import{SocketHandler, LifeCycle, MicroService, UnitSystem} from'@/assets/javascript/mixins/Mixins'
import {lowerCaseObject} from '@/assets/javascript/utilities'

import InputElement from'@/components/elements/InputElement.vue'
import SelectElement from'@/components/elements/SelectElementReactive.vue'

import PrecipitationCalculatorElement from'@/components/elements/PrecipitationCalculatorElement'
import SprayPrecipitationCalculatorElement from'@/components/elements/SprayPrecipitationCalculatorElement'

export default {
  name: 'EditStationSprinklers',
  components:
  {
    'precipitation-calculator': PrecipitationCalculatorElement,
    'spray-precipitation-calculator': SprayPrecipitationCalculatorElement,
    'input-element': InputElement,
    'select-element': SelectElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService, UnitSystem],
  props:
  {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    station: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      sprinklerType: null,
      sprinklerTypes: [],
      ratings: null
    }
  },
  computed: {
    rating() {
      return this.findValueInArray(this.ratings, this.station.effic)
    },
    computedPrecipitationRate() {
      let rtn = 0
      if(this.station.sprinklType === '4' || this.station.sprinklType === '5') {
        rtn = this.station.precip
      } else if(!(this.computedSprinklerTypes && this.station.sprinklType !== null)) {
        rtn = 0
      } else {
        const type = this.computedSprinklerTypes.find((sprinklerType) => sprinklerType.value === this.computedSprinklerType)
        rtn = type ? type.precip : 0
      }
      return this.convertUnits(rtn / 100, 'in', 'cm')
    },
    computedSprinklerType() {
      return this.findValueInArray(this.computedSprinklerTypes, this.station.sprinklType)
    },
    computedSprinklerTypes() {
      return this.sprinklerTypes
      ? this.sprinklerTypes.map((sprinklerType) => ({value: sprinklerType.id, label: sprinklerType.name, precip: sprinklerType.precip})).sort((a, b) => (a.value > b.value) ? 1 : -1)
      : null
    },
    computedCustom() {
      return !isNaN(this.sprinklerType) ? this.sprinklerType : null
    }
  },
  created() {
    const mockRequest = new Promise((resolve, reject) => {
      resolve([{  
        id: '0',
        name: 'None',
        precip: '0'
      }, {
        id: '1',
        name: 'Fixed Spray',
        precip: '150'
      }, {  
        id: '2',
        name: 'Rotor',
        precip: '60'
      }, {  
        id: '3',
        name: 'Impact',
        precip: '40'
      }, {  
        id: '4',
        name: 'Custom',
        precip: '0'
      }, {  
        id: '5',
        name: 'Drip / Micro Spray',
        precip: '0'
      }])
    })

    mockRequest.then((result) => this.$set(this, 'sprinklerTypes', result))

    const mockRequestRatings = new Promise((resolve, reject) => {
      resolve([{
        id: '50',
        value: 'Very Poor 50%'
      }, {  
        id: '55',
        value: 'Fair 55%',
      }, {  
        id: '65',
        value: 'Good 65% HC',
      }, {  
        id: '70',
        value: 'very good 70%',
      }, {  
        id: '80',
        value: 'Excellent 80%',
      }])
    })

    const mockRequestRating = new Promise((resolve, reject) => resolve('0'))

    mockRequestRatings.then((result) => this.$set(this, 'ratings', result.map(rating => ({value: rating.id, label: rating.value}))))
  },
  methods: {
    setPrecip(val) {
      console.log(val, val.target)
      if(isNaN(val))
        val = val.target.value

      this.updateStation({precip: val * 100})
    },
    findValueInArray: (ary, item) => ary && ary.length && item
      ? ary.find(cur => cur.value === item).value
      : null
    ,
    updateStation(fields) {
      this.SocketMessageSend(
        Object.assign({}, {
          Category: 'Stations',
          Type: 'StationData',
          Oper: 'Upd',
          Seq: this.station.decId
        },
        lowerCaseObject(fields))
      )
      Object.keys(fields).forEach(key=> this.$set(this.station, key, '' +  fields[key])) // @TODO: Should be done with return data when ready
    },
    setSprinklerType(val) {
      this.updateStation({sprinklType: val.value})
      this.$nextTick(() => this.updateStation({
        precip: this.convertUnits(this.computedPrecipitationRate * 100, 'cm', 'in')
      }))
    },
    setRating(val) {
      this.updateStation({effic: val.value})
    }
  }
}
</script>

<style lang="scss">
  .edit-station-sprinklers {
    .grid__title {
      margin-bottom: 0;
    }
    
    &__title {
      padding: 5px;
      margin: 5px;
      font-size: 14px;
      font-family: 'Montserrat-SemiBold';
      font-weight: normal;
    }

    .precipitationrate {
      margin-top: 18px;
    }
  }
</style>
